module.exports = __webpack_public_path__ + "img/1.0ee30cad.png";